import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-addholidays',
  templateUrl: './addholidays.component.html',
  styleUrls: ['./addholidays.component.css']
})
export class AddholidaysComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "Holidays";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  ismanualclose: boolean;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  holidaysColl: any = [];
  holidaysBO: any = {};

  holidaysid: number = 0

  holidaysform = new FormGroup({
    holidaysid: new FormControl(0),
    holidaysname: new FormControl('', Validators.required),
    startdt: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  //filter
  filterfromdate: any = null;
  filtertodate: any = null;
  filterstatus: string = "ALL";

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.holidaysid = params.id
      }
    });

    this.fnServiceChanges();
    this.fnGetParameterVariable();

  this.dateCustomClasses = [
    { date: new Date(), classes: ['bg-warning'] },
  ];
}
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.holidaysform.reset();
      this.fnInitializeFormGroup();

      if (this.holidaysid > 0) {
        this.fngetHolidays();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.holidaysid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.holidaysform.setValue({
      holidaysid: 0,
      holidaysname: '',
      startdt: new Date(),
      inactive: false
    })
  }

  //Get 
  fngetHolidays() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'holidaysid': this.holidaysid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getHolidays(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.holidaysColl = res.json().result;
            var editdata = this.holidaysColl[0];
            this.fnEditMode(editdata);
            this.holidaysBO = editdata;
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.holidaysform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'holidaysid': this.holidaysid,
          'holidaysname': this.holidaysform.get('holidaysname').value,
          'branchid': 0,
          'startdt': this.fnFormatDatetime(this.holidaysform.get('startdt').value),
          'inactive': this.holidaysform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckHolidays(data).subscribe(
          (res) => {
            console.log(res)
            if (res.json().status === 200) {
             
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.holidaysform.get('holidaysid').value > 0) {
                  //Update 
                  this.fnSetHolidays(data);
                }
                else {
                  //Insert 
                  this.fnInsertHolidays(data);
                }
              }
              else {
                if (_checkresult === "DATE") {
                  this.saveloading = false;

                  this.holidaysform.controls['startdt'].setErrors({ 'notfound': true });
                }
                else if (_checkresult === "NAME") {
                  this.saveloading = false;

                  this.holidaysform.controls['holidaysname'].setErrors({ 'notfound': true });
                }
              }
            }
            else { this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => { this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) { this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertHolidays(data) {

    this.appService.fnInsertHolidays(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            console.log(res.json())
            this.toastr.success('', "The new holidays has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.holidaysname);
            this.fnCloseForm();
            this.ismanualclose = true;
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetHolidays(data) {

    this.appService.fnSetHolidays(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The holidays has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.holidaysid, data.holidaysname);
            this.ismanualclose = true;
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {
    deptBO.startdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.startdt));

    this.holidaysform.setValue({
      holidaysid: deptBO.holidaysid,
      holidaysname: deptBO.holidaysname,
      startdt: deptBO.startdt,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }
  fnEditFormEdit(id) {

  
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
     
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
    }

    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });

  }
    //Close
    async fnCloseForm() {
      try {
        if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
          var a = await this.loginService.fnConfirmFormLeave();
          if (a === false) {
            return false;
          }
        }
  
        this.ismanualclose = true;
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
         
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
          }
        }
  
        this.router.navigate(['/Holidays'], navigationExtras);
      } catch (ex) {
        this.fnShowErrorMsg(ex);
      }
    }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








}
